import { useEffect } from "react";
import { X } from "lucide-react";
import { AppointmentRequest } from "./AppointmentRequest";

export const BookingDialog = ({ open, onClose, choiceLabel, variant }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      data-testid="booking-dialog"
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/55 p-2 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="Request your appointment times"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="flex max-h-[94vh] sm:max-h-[90vh] w-full max-w-4xl flex-col bg-white shadow-2xl">
        <div className="flex items-center justify-between gap-3 border-b border-[var(--brand-gold-soft)] px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3 min-w-0">
            <img src="/images/logo.png" alt="" aria-hidden="true" className="h-10 w-10 shrink-0 object-contain hidden sm:block" />
            <div className="min-w-0">
              <p className="font-serif-brand font-semibold text-[var(--brand-navy)] leading-tight">
                Request a time with Dr. Crosson
              </p>
              <p className="text-xs sm:text-sm text-[var(--brand-muted)] truncate">
                <span className="font-semibold text-[var(--brand-navy)]">{choiceLabel}</span> visit
                &mdash; the office will confirm with you.
              </p>
            </div>
          </div>
          <button
            data-testid="booking-close-button"
            onClick={onClose}
            aria-label="Close booking window"
            className="p-2 shrink-0 text-[var(--brand-muted)] hover:text-[var(--brand-navy)] transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="h-0.5 bg-[var(--brand-gold)]" aria-hidden="true" />
        <div className="flex-1 overflow-y-auto">
          <AppointmentRequest visitType={choiceLabel} variant={variant} />
        </div>
      </div>
    </div>
  );
};
